export const enChiffres = {
  our: "OUR",
  keyNumbers: "KEY NUMBERS",
  subtitle: "THE FIGURES THAT REFLECT OUR COMMITMENT AND EXCELLENCE",
  projectsCompleted: "Projects Completed",
  satisfiedClients: "Satisfied Clients",
  awardsWon: "On-time delivery",
  satisfactionRate: "Satisfaction Rate",
  yearsExperience: "Years of Experience",
  collaborators: "Collaborators"
};

export const frChiffres = {
  our: "NOS",
  keyNumbers: "CHIFFRES CLÉS",
  subtitle: "LES CHIFFRES QUI REFLÈTENT NOTRE ENGAGEMENT ET NOTRE EXCELLENCE",
  projectsCompleted: "Projets Réalisés",
  satisfiedClients: "Clients Satisfaits",
  awardsWon: "Livraison à Temps",
  satisfactionRate: "Taux de Satisfaction",
  yearsExperience: "Années d'Expérience",
  collaborators: "Collaborateurs"
};

export const nlChiffres = {
  our: "ONZE",
  keyNumbers: "BELANGRIJKE CIJFERS",
  subtitle: "DE CIJFERS DIE ONZE TOEWijding EN EXCELLENTIE WEERGEVEN",
  projectsCompleted: "Voltooide Projecten",
  satisfiedClients: "Tevreden Klanten",
  awardsWon: "Op Tijd Geleverd",
  satisfactionRate: "Tevredenheidspercentage",
  yearsExperience: "Jaar Ervaring",
  collaborators: "Medewerkers"
};

export const deChiffres = {
  our: "UNSERE",
  keyNumbers: "KENNZAHLEN",
  subtitle: "DIE ZAHLEN, DIE UNSER ENGAGEMENT UND UNSERE EXZELLENZ WIDERSPIEGELN",
  projectsCompleted: "Abgeschlossene Projekte",
  satisfiedClients: "Zufriedene Kunden",
  awardsWon: "Pünktliche Lieferung",
  satisfactionRate: "Zufriedenheitsrate",
  yearsExperience: "Jahre Erfahrung",
  collaborators: "Mitarbeiter"
};